export default __webpack_public_path__ + "static/media/main.67fa895d.png";